// v65 — Live Streaming Intel access. Null (no access) while pending or on a 404.
// v88 — loaded through accessLoader: a failed check is retried, never read as "no access".
import { makeAccess } from "@/lib/accessLoader";

const LIVE = makeAccess("live", "/live-intel/access", (d) => d || null);
export const resetLiveIntelAccess = LIVE.reset;

export function useLiveIntelAccess() {
  const { value, ready } = LIVE.useAccess();
  return { features: value, enabled: !!value, ready };
}

export function liveSubtitle(f) {
  const parts = ["Live viewers"];
  if (f?.chat) parts.push("chat");
  if (f?.bot) parts.push("live bot check");
  return parts.join(", ");
}

export function liveCardBody(f) {
  const chat = f?.chat ? ", how busy their chat is" : "";
  const bot = f?.bot ? ", plus a live bot check" : "";
  return `Every creator who goes live: their typical live crowd, their stream frequency${chat} and when they last went live${bot}.`;
}
